import { useCallback, useState } from 'react';

import { PageTitle } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import GridApplication from 'app/components/grid/gridApplication';
import { FileEarmarkText } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { type TaxReturnSummary } from '@/app/modules/tax-returns/models/TaxReturn';
import env from '@/env';

import { BaseUrPaymentDeclaration } from '../../services/payment.service';

import { getColumns } from './columns';
import { SelectTaxReturnFilters } from './filters';
import { type TaxReturnFilter } from './search';

export const PaymentSelectTaxReturnPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [filters, setFilters] = useState<TaxReturnFilter>({});

  const handleViewTaxReturn = (tr: TaxReturnSummary) => {
    const url = `${env.appUrl}/reports/taxreturn/preview/${tr.id}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleRegisterPayment = useCallback(
    (tr: TaxReturnSummary) => {
      navigate(`/payments/declaration/record?taxReturnId=${tr.id}`);
    },
    [navigate]
  );

  const handleSearch = (filter: TaxReturnFilter) => {
    setFilters(filter);
  };

  const handleClear = () => {
    setFilters({});
  };

  const columns: Array<ColDef> = getColumns(true, handleViewTaxReturn, handleRegisterPayment);

  return (
    <>
      <PageTitle title={t('taxpayer-payments.title.selectTaxReturn')} icon={FileEarmarkText} />

      <SelectTaxReturnFilters onSearch={handleSearch} onClear={handleClear} />

      <div className="mt-3">
        <GridApplication
          url={`${BaseUrPaymentDeclaration}/tax-returns`}
          columnDefs={columns}
          search={filters}
        />
      </div>
    </>
  );
};

PaymentSelectTaxReturnPage.displayName = 'PaymentSelectTaxReturnPage';
